<template>
  <Card class="searchcard">
    <Row :gutter="2">
      <Col span="4">
        <Treeselect v-model="formData.categoryid" :multiple="false" :options="categoryTree" />
      </Col>

      <Col span="3">
        <RadioGroup style="padding-top:6px" class="m-l-10" v-model="formData.is_show">
          <Radio :label="1">显示</Radio>
          <Radio :label="0">不显示</Radio>
        </RadioGroup>
      </Col>
      <Col span="4">
        <Input v-model="formData.keywords" placeholder="查询关键字" />
      </Col>

      <Col span="2">
        <Button class="btn btn-theme" @click="fn_submit_search">
          <i class="fa fa-search"></i> 查询
        </Button>
      </Col>
    </Row>
  </Card>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: { Treeselect },
  data() {
    return {
      formData: {
        categoryid: 0,
        is_show: 99,
        keywords: "",
        page: 0,
        pageNum: 15
      }
    };
  },
  mounted() {},
  methods: {
    fn_submit_search() {
      this.$emit("on-search", this.formData);
    }
  },
  props: ["categoryTree"]
};
</script>
